import Footer from 'components/common/Footer'
import Logo from 'components/common/Logo'
import { Outlet } from 'react-router'

function AuthLayout() {
  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Animated background orbs */}
      <div className="background-orbs">
        <div className="orb orb-1"></div>
        <div className="orb orb-2"></div>
        <div className="orb orb-3"></div>
      </div>

      <main className="d-flex flex-column flex-grow-1">
        <section className="flex-grow-1 d-flex flex-column align-items-center justify-content-center">
          <Logo alt="logo" className="mb-4" height={50} />
          <h3 className="text-center text-lighter fw-semibold mt-3">Welcome to FinOps Center</h3>
          <p className="text-center text-muted fst-italic mb-4">Your AWS CFM and AI Cost Governance Control Plane</p>

          <div className="w-100" style={{ maxWidth: '450px' }}>
            <Outlet />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  )
}
export default AuthLayout
